import { ReactElement, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "contexts/auth";
import Spinner from "components/Spinner";
import { redirectToBffLogin } from "utils/auth/bffRedirect";

const FullScreenSpinner = (): ReactElement => (
  <div className={"w-full mt-9 flex justify-center items-center"}>
    <Spinner />
  </div>
);

/**
 * Guards the private route group. Auth state comes from the BFF cookie session
 * (via `useAuth`); there is no JS-readable token. While auth is resolving, or
 * when the user is unauthenticated (redirect in flight), we render the spinner
 * and NEVER the private children, so private content can't flash before the
 * browser navigates to the BFF login endpoint.
 */
const RequireAuth = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  const location = useLocation();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      redirectToBffLogin(location.pathname + location.search);
    }
  }, [loading, user, location.pathname, location.search]);

  if (loading || !user) {
    return <FullScreenSpinner />;
  }

  return children;
};

export default RequireAuth;
